import { useCanShowAdvancedForm } from '../hooks/useCanShowAdvancedForm'

import { AutomatedMessageEnabledField } from './fields/AutomatedMessageEnabledField'
import { AutomatedMessageField } from './fields/AutomatedMessageField'
import { AutomatedMessageVoiceField } from './fields/AutomatedMessageVoiceField'
import { CallbackConfigStatusField } from './fields/CallbackConfigStatusField'
import { PhoneField } from './fields/PhoneField'
import { StatusField } from './fields/StatusField'
import { useConnectToAutomatedMessageEnabled } from './fields/hooks/useConnectToAutomatedMessageEnabled'
import { useConnectedToBackOfficePhone } from './fields/hooks/useConnectedToBackOfficePhone'
import { useConnectedToStatusFields } from './fields/hooks/useConnectedToStatusFields'
// import { RestrictionsField } from './fields/RestrictionsField'

import { VoiceAlert } from './VoiceAlert/VoiceAlert'

export function FormContent() {
  const canShowAdvancedForm = useCanShowAdvancedForm()

  useConnectedToStatusFields()
  useConnectedToBackOfficePhone()
  useConnectToAutomatedMessageEnabled()

  return (
    <>
      <StatusField />
      <VoiceAlert />
      {canShowAdvancedForm && (
        <>
          {/* TODO: Re-enable that field once it will be available */}
          {/* <RestrictionsField /> */}

          <CallbackConfigStatusField />

          <PhoneField />

          <AutomatedMessageEnabledField />

          <AutomatedMessageField />

          <AutomatedMessageVoiceField />
        </>
      )}
    </>
  )
}
